// KeepAwake: holds a screen wake lock while the element is on the page, so a
// tablet does not dim and lock mid-upload. The browser drops the lock itself
// when the tab is hidden (e.g. the camera app opens), so it is requested again
// when the tab becomes visible. No Wake Lock API or a refused request: nothing
// happens, one console.debug.
export const KeepAwake = {
  mounted() {
    this.lock = null
    this.pending = false
    this.gone = false
    this.onVisible = () => {
      if (document.visibilityState === "visible") this.request()
    }
    document.addEventListener("visibilitychange", this.onVisible)
    this.request()
  },

  async request() {
    if (this.gone || this.lock || this.pending) return
    if (!navigator.wakeLock) {
      console.debug("KeepAwake: Wake Lock API is not available")
      return
    }
    this.pending = true
    try {
      const lock = await navigator.wakeLock.request("screen")
      if (this.gone) {
        lock.release().catch(() => {})
        return
      }
      this.lock = lock
      lock.addEventListener("release", () => {
        if (this.lock === lock) this.lock = null
      })
    } catch (err) {
      console.debug("KeepAwake: wake lock refused", err)
    } finally {
      this.pending = false
    }
  },

  destroyed() {
    this.gone = true
    document.removeEventListener("visibilitychange", this.onVisible)
    if (this.lock) this.lock.release().catch(() => {})
    this.lock = null
  }
}
